import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";

const AWSGuide = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_POLICY_DOC_URL}/cf.yaml`;
    link.download = `awsTemplate`;
    link.click();
  };

  return (
    <Box sx={{ mt: 2, px: 1 }}>
      <Paper
        elevation={1}
        sx={{ p: 2, mb: 2, bgcolor: "background.paper", borderRadius: 2 }}
      >
        <Typography variant="subtitle1" gutterBottom fontWeight="medium">
          Step 1: Download CloudFormation Template
        </Typography>
        <Typography variant="body2" gutterBottom>
          Download our template to set up the required AWS resources and
          permissions.
        </Typography>
        <Button
          variant="outlined"
          startIcon={<DescriptionIcon />}
          sx={{ mt: 1, borderRadius: 1.5 }}
          onClick={handleDownload}
          color="primary"
        >
          Download AWS Template
        </Button>
      </Paper>

      <Paper
        elevation={1}
        sx={{ p: 2, bgcolor: "background.paper", borderRadius: 2 }}
      >
        <Typography variant="subtitle1" gutterBottom fontWeight="medium">
          Step 2: Deploy the Template
        </Typography>
        <Typography variant="body2" paragraph>
          Deploy the downloaded template in your AWS account:
        </Typography>
        <ol>
          <li>Sign in to your AWS Management Console</li>
          <li>Navigate to CloudFormation service</li>
          <li>Click "Create stack" and upload the template</li>
          <li>Follow the wizard to complete deployment</li>
        </ol>
        <Typography variant="body2" paragraph>
          After deployment completes, copy the generated ARN from the Outputs
          tab.
        </Typography>
      </Paper>
    </Box>
  );
};

export default AWSGuide;
